var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      !_vm.isContentExists
        ? _c("p", { staticClass: "text-gray-400" }, [
            _vm._v(" " + _vm._s(_vm.placeholder) + " "),
          ])
        : _vm._l(_vm.formatedDescription, function (paragraph, index) {
            return _c("p", { key: index, staticClass: "mb-1" }, [
              _vm._v(" " + _vm._s(paragraph) + " "),
            ])
          }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }